import { cn } from "@util/helpers";

import { COMMON_BUTTON_CSS, REMOVE_FOCUS_CSS } from "./utils/constants";
import { ActionType, ButtonProps, SocialMediaType } from "./utils/types";
import SocialEmbedButtonFactory from "./SocialMediaButtonFactory";

export default function Button({
  className = "",
  whichSocialMedia = SocialMediaType.facebook,
  shareUrl = "",
  actionType = ActionType.actionButton,
  icon,
  text,
  title = "",
  onClick,
  callback,
  buttonSize,
  iconSize = 24,
  testId = "",
  children,
}: ButtonProps) {
  const commonCss = `${REMOVE_FOCUS_CSS} ${COMMON_BUTTON_CSS}`;

  switch (actionType) {
    case ActionType.shareButton:
      return (
        <SocialEmbedButtonFactory
          commonCss={commonCss}
          whichSocialMedia={whichSocialMedia}
          shareUrl={shareUrl}
          className={className}
          title={title}
          iconSize={iconSize}
          buttonSize={buttonSize}
          text={text}
          callback={callback}
        />
      );

    case ActionType.actionButton:
    default:
      return (
        <button
          className={cn(
            commonCss,
            {
              "aspect-square": icon && !text,
            },
            className
          )}
          onClick={onClick}
          data-size={buttonSize}
          data-testid={testId}
        >
          {children}
        </button>
      );
  }
}
